import React, { useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';

import GlobalTooltip from 'components/GlobalTooltip';
import { automationStatusFilter } from 'constants/dropdownOptions';
import { usePracticeAreaList } from 'hooks/usePracticeAreaList';
import { useCaseMatter } from 'hooks/useCaseMatter';

export default function Filter(props) {
  const { practiceAreaList, isPracticeAreaLoading } = usePracticeAreaList();
  const { caseMatterList, isCaseMatterLoading, loadCaseMatter } = useCaseMatter();
  const { filter, refreshList, filterOnChange } = props;
  return (
    <div className="d-inline-flex filter-wrap autowidth">
      <div>
        <span className="p-input-icon-left input-shadow"></span>
      </div>
      <div className="d-flex align-items-center autowidth">
        <div className="d-flex align-items-center p-2 automation-filter filter-wraper gap-2">
          <span className="text-bold black-600 me-2">Filters: </span>

          <Dropdown
            value={filter?.practice_area}
            options={practiceAreaList}
            onChange={(e) => {
              filterOnChange(e);
              loadCaseMatter(e.value);
            }}
            placeholder="By Practice Area"
            isFilter={true}
            name="practice_area"
            optionValue="practice_area_id"
            optionLabel="practice_area_name"
            dropdownIcon={isPracticeAreaLoading ? 'pi pi-spin pi-spinner' : undefined}
            showClear
            resetFilterOnHide
            filter
          />
          <Dropdown
            name="case_matter"
            value={filter?.case_matter}
            options={caseMatterList}
            onChange={filterOnChange}
            placeholder="By Case Matter"
            optionLabel="matter_name"
            optionValue="case_matter_id"
            resetFilterOnHide
            filter
            className="searchable-dropdown input-shadow "
            showClear
            dropdownIcon={isCaseMatterLoading ? 'pi pi-spin pi-spinner' : undefined}
          />
          <Dropdown
            value={filter?.automation_status}
            options={automationStatusFilter}
            onChange={filterOnChange}
            placeholder="By Status"
            name="automation_status"
            isFilter={false}
          />

          <div className="pointer ms-0 p-2">
            <GlobalTooltip tooltip="Clear Filter" position="top" target=".fa-sync-alt" showDelay={500}>
              <i className="fas fa-sync-alt" onClick={() => refreshList()}></i>
            </GlobalTooltip>
          </div>
        </div>
      </div>
    </div>
  );
}
